import React from "react";
import Header from "../component/Header";
import ExploreResultLocations from "../component/ExploreResultLocations";
import Footer from "../component/Footer";
import ConnectAgentCTA from "../component/ConnectAgentCTA";
import CommonBanner from "../component/CommonBanner";
import { Col, Container } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useBlogList } from "../hooks/useBlogList";

function Blogs() {
  const { blogs, loading, error } = useBlogList();

  return (
    <>
      <div className="main blog-page">
        <Header />
        <CommonBanner title="Blogs" />
        <div className="blog-list common-padding">
          <Container>
            <div className="common-header">
              <h2 className="mb-0">Letest <span>Blogs</span></h2>
            </div>
            <Row className="row-gap-4">
              {loading && <p>Loading blogs...</p>}
              {error && <p className="text-danger">{error}</p>}
              {!loading && !error && blogs.length === 0 && <p>No blogs found</p>}
              {!loading && blogs.map((blog) => (
                <Col lg={4} md={6} sm={12} key={blog.id}>
                  <Link to={`/blogs-details/${blog.slug || blog.id}`} className="blog-item">
                    <div className="blog-image">
                      <img 
                        src={blog.image}
                        alt={blog.title} 
                      />
                    </div>
                    <div className="blog-content">
                      <p>{blog.category_name}</p>
                      <h3>{blog.title}</h3>
                    </div>
                  </Link>
                </Col>
              ))}
            </Row>
          </Container>
        </div>
        <ConnectAgentCTA />
        <ExploreResultLocations />
        <Footer />
      </div>
    </>
  );
}

export default Blogs;
